import { CountryCode } from '@crehana/ts-types';

export interface ZipCodeFormData {
  maxLength: number;
  hint: string;
}

const DEFAULT_ZIP_CODE_FORM_DATA: ZipCodeFormData = {
  maxLength: 9,
  hint: '',
};

const getZipCodeData = (countryPrefix: CountryCode): ZipCodeFormData => {
  switch (countryPrefix) {
    case 'ar':
      return { maxLength: 4, hint: 'Ejemplo: 1045 o 1638' };
    case 'br':
      return { maxLength: 9, hint: 'Exemplo: 61919-230' };
    default:
      return DEFAULT_ZIP_CODE_FORM_DATA;
  }
};

export default getZipCodeData;
